import { holdReasons, rejectionReasons } from "./stageDialogConfig"

export type StageMoveDialogType = "reason_note" | "salary_input"

export interface StageMoveDialogConfig {
  stage: string
  type: StageMoveDialogType
  title: string
  description: string
  confirmButtonText: string
  reasons?: { value: string; label: string }[]
  // For salary_input
  defaultSalary?: number
}

export const stageMoveDialogsByStage: Record<string, StageMoveDialogConfig> = {
  rejected: {
    stage: "rejected",
    type: "reason_note",
    title: "Rejection Reason",
    description: "Please select a reason for rejecting this applicant.",
    confirmButtonText: "Reject Applicant",
    reasons: rejectionReasons,
  },
  hold: {
    stage: "hold",
    type: "reason_note",
    title: "Hold Reason",
    description: "Please select a reason for putting this applicant on hold.",
    confirmButtonText: "Put on Hold",
    reasons: holdReasons,
  },
  contract: {
    stage: "contract",
    type: "salary_input",
    title: "Set Contract Salary",
    description:
      "Please enter the contract salary for {name}. This will be saved to the application.",
    confirmButtonText: "Save Salary & Continue",
  },
}

export const getStageMoveDialogForStage = (stage: string): StageMoveDialogConfig | null =>
  stageMoveDialogsByStage[stage] ?? null
